import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ApplicationOverlayConfig } from "@interfaces/interfaces";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { ApplicationOverlayService } from "@services/application-overlay.service";

@Component({
  selector: "application-overlay",
  templateUrl: "./application-overlay.html",
  styleUrls: ["./application-overlay.scss"],
  standalone: true,
  imports: [TranslateModule, IonicModule, CommonModule],
})
export class ApplicationOverlayComponent {
  private overlayService = inject(ApplicationOverlayService);

  get config(): ApplicationOverlayConfig {
    return this.overlayService.overlayConfig();
  }

  handleClick() {
    this.config.buttonAction();
  }
}
